import moment from 'moment';

import { capitalizeFirstLetter } from '../strings';

export const formatFullDate = (date) => moment.parseZone(date).utcOffset(offset).format('DD/MM/YYYY [às] HH[h]mm');

export const offset = moment().utcOffset();

export const dateFormat = (dateTime) => {
  if (!dateTime) {
    return '';
  }
  const data = new Date(dateTime),
    dia = data.getDate().toString(),
    diaF = dia.length === 1 ? '0' + dia : dia,
    mes = (data.getMonth() + 1).toString(),
    mesF = mes.length === 1 ? '0' + mes : mes,
    anoF = data.getFullYear();
  return diaF + '/' + mesF + '/' + anoF;
};

export const timeFormat = (dateTime) => {
  if (!dateTime) {
    return '';
  }
  const date = new Date(dateTime);
  return date.toLocaleTimeString('pt-BR').substring(0, 5);
};

export const dateTimeFormat = (dateTime) => {
  if (!dateTime) {
    return '';
  }
  return `${dateFormat(dateTime)} ${timeFormat(dateTime)}`;
};

export const getLastThreeMonths = () => {
  const lastThreeMonths = [] as string[];

  for (let i = 0; i <= 2; i++) {
    lastThreeMonths.push(capitalizeFirstLetter(moment().clone().subtract(i, 'months').format('MMMM/YY')));
  }

  return lastThreeMonths.reverse();
};
